import useNavigateGuard from '@/utilities/hooks/useNavigateGuard';
import { Button, Typography } from 'br2s-ui-componentlibrary_r2_02';
import { SystemIcon } from 'br2s-ui-componentlibrary_r2_02/dist/foundation/assets/system-icon';

export interface ContentHeaderProps {
  title: string;
  description: string;
  backButtonLabel: string;
  onBackClick: () => void;
  overviewHref?: string;
  closeDropdown: (t?: boolean) => void;
}

const ContentHeader = ({
  title,
  description,
  backButtonLabel,
  overviewHref,
  onBackClick,
  closeDropdown,
}: ContentHeaderProps) => {
  const guardedNavigate = useNavigateGuard();

  return (
    <div className="mega-menu-content-header">
      <div className="container">
        <div className="back-button-cont">
          <Button
            id={`${title}-back`}
            label={backButtonLabel}
            type="quiet"
            iconClassName={SystemIcon.NavigationChevronLeft}
            iconType="prepended"
            onClick={onBackClick}
          />
        </div>
        <div className="title-container">
          <div>
            <Typography type="headline-3" label={title} weight="bold" />
            <Typography label={description} />
          </div>
          {overviewHref && (
            <Button
              id={`${title}-overview`}
              type="secondary"
              label="Overview"
              onClick={() => {
                closeDropdown(true);
                guardedNavigate(overviewHref);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentHeader;
